interface EntranceCard {
  id: string;
  title: string;
  description: string;
  icon: string;
  link: string;
  badge: string;
  badgeColor: string;
}

interface EntranceSectionProps {
  title: string;
  subtitle: string;
  cards: EntranceCard[];
}

export default function EntranceSection({ title, subtitle, cards }: EntranceSectionProps) {
  return (
    <section id="entrance" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            {title}
          </h2>
          <p className="text-sm text-foreground-600">
            {subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {cards.map((card) => (
            <a
              key={card.id}
              href={card.link}
              className="group relative bg-background-50 rounded-2xl p-8 border border-background-200/70 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <span className={`absolute top-4 right-4 px-2.5 py-0.5 rounded-full text-xs font-semibold text-white ${card.badgeColor}`}>
                {card.badge}
              </span>

              <div className="w-14 h-14 rounded-xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-200 transition-colors">
                <i className={`${card.icon} text-2xl text-primary-600`}></i>
              </div>

              <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2">
                {card.title}
              </h3>

              <p className="text-sm text-foreground-600 leading-relaxed">
                {card.description}
              </p>

              <div className="mt-5 flex items-center gap-1 text-primary-600 font-medium text-sm">
                <span>立即访问</span>
                <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}